import * as action_types from './action_types';

export const showHelpbox = (data) => ({
  type: action_types.SHOW_HELPBOX,
  data: {
    isShowing: true,
    type: data.type,
  },
});

export const hideHelpbox = () => ({
  type: action_types.HIDE_HELPBOX,
  data: {
    isShowing: false,
  },
});
